import React from "react";
import MapViewContainer from "../../containers/Map";

function Map(props) {
  return <MapViewContainer {...props} />;
}

export default Map;
